import { empty } from '../asyncValue';
import type { Match, RevisionLicense } from '../../../shared/licenses/common';
import type {
  MatchOverride,
  MatchOverrideWithHashFilter,
  MatchOverrideWithLicenseFilter,
  MatchOverrideWithNewLicense,
  Project,
  Revision,
  Task,
} from '../../types';
import type { AsyncValue } from '../asyncValue';

/** State for the Global License Corrections card. */
export type GLCState = {
  licenses: AsyncValue<RevisionLicense[]>;
  overrides: AsyncValue<MatchOverride[]>;
  project: AsyncValue<Project>;
  revision: AsyncValue<Revision>;
  scheduledTask: AsyncValue<Task>;
};

export const initialState: GLCState = {
  licenses: empty(),
  overrides: empty(),
  project: empty(),
  revision: empty(),
  scheduledTask: empty(),
};

/** A structure holding a match and it's associated overrides. */
export type MatchAndOverrides = {
  match?: Match;
  overrides: MatchOverrideWithHashFilter[];
};

/**
 * A structure holding the whole tree of licenses, overrides and matches for a
 * revision.
 */
export type RevisionLicenseAndMatchesAndOverrides = {
  licenseId: string;
  licenses: RevisionLicense[];
  newOverrides: MatchOverrideWithNewLicense[];
  licenseOverrides: MatchOverrideWithLicenseFilter[];
  matches: MatchAndOverrides[];
};
